import _ from 'lodash';

export function isActiveOrder(order) {
  return order.shipping
    ? ['Awaiting Fulfillment', 'Shipped'].indexOf(order.shipping_status) !== -1
    : [0, 1, 2, 7].indexOf(order.order_status) !== -1;
}

export function isAwaitingShipmentOrder(order) {
  return order.shipping && order.shipping_status === 'Awaiting Fulfillment';
}

export function isEnRouteShippingOrder(order) {
  return order.shipping && order.shipping_status === 'Shipped';
}

export function isCompletedShippingOrder(order) {
  return order.shipping && order.shipping_status === 'Completed';
}

export function isAcceptedOrder(order) {
  return (
    !order.shipping && (order.order_status === 0 || order.order_status === 1)
  );
}

export function isPickedUpOrder(order) {
  return !order.shipping && order.order_status === 7;
}

export function isInProgressOrder(order) {
  return !order.shipping && order.order_status === 2;
}

export function isEnRouteOrder(order) {
  return !order.shipping && [2, 3, 7].indexOf(order.order_status) !== -1;
}

export function isCompletedOrder(order) {
  return order.shipping
    ? order.shipping_status === 'Completed'
    : order.order_status === 3;
}

export function isFailedOrder(order) {
  return order.shipping
    ? order.shipping_status === 'Failed'
    : order.order_status === 4;
}

export function isCanceledOrder(order) {
  return order.shipping
    ? order.shipping_status === 'Cancelled'
    : order.order_status === 5;
}

export function isRejectedOrder(order) {
  return order.order_status === -1;
}

export function isReturnedOrder(order) {
  return order.shipping && order.shipping_status === 'Partially Refunded';
}

export const SCHEDULED = 6;

export function isScheduledOrder(order) {
  return order.order_status === SCHEDULED;
}

export function isTotalLineItem({ title }) {
  return (title || '').toLowerCase() === 'total';
}

export function orderTotal({ line_items }) {
  const totalLineItem = _.find(line_items, isTotalLineItem) || {};
  return totalLineItem.display;
}
